import { useEffect, useState } from "react";
import { useMarket } from "../../../api/hooks/useMarket";
import { HistDataResp, MarketResp } from "../../../api/types/MarketResp";
import { useAppSelector } from "../../hooks";
import { selectIDs } from "../../market/marketSlice";
import { idType } from "../../market/types";
import { allIDs } from "../../../api/constants/geckoIDs";

export const useZoom = () => {
  const tokenIDs = useAppSelector(selectIDs);
  const marketFuncs = useMarket();
  //   const [tokenIDs, setTokenIDs] = useState<idType[]>([]);

  const findGeckoId = (symbol: string, tokenIDs: idType[]): idType => {
    let geckoObj = {} as idType;
    tokenIDs.forEach((geckoID: idType) => {
      if (geckoID.symbol === symbol.toLowerCase()) {
        //returns first element that matches because the others are incorrect
        //there are multiple matches in CoinGecko's ID list :(
        geckoObj = geckoID;
        return
      }
    });

    return geckoObj;
  };

  useEffect(() => {
    // const load = async () => {
    //     const ids = await marketFuncs.getIDs();
    //     setTokenIDs(ids);
    // }
    // load();
  }, []);

  return {
    getDay: async (tokens: string[]) => {
      let promises: any[] = [];
      let geckoIDs: string[] = [];
      const ids = allIDs;
      tokens.map((token) => {
        geckoIDs.push(findGeckoId(token, ids).id);
      });
      geckoIDs.forEach((id) => {
        promises.push(marketFuncs.getPrice(id, "day"));
      });
      return Promise.all(promises);
    },

    getWeek: async (tokens: string[], tokenIDs: idType[]) => {
      let promises: any[] = [];
      let geckoIDs: string[] = [];
      tokens.map((token) => {
        geckoIDs.push(findGeckoId(token, tokenIDs).id);
      });
      geckoIDs.forEach((id) => {
        promises.push(marketFuncs.getPrice(id, "week"));
      });
      return Promise.all(promises);
    },

    getMonth: async (tokens: string[], tokenIDs: idType[]) => {
      let promises: any[] = [];
      let geckoIDs: string[] = [];
      tokens.map((token) => {
        geckoIDs.push(findGeckoId(token, tokenIDs).id);
      });
      geckoIDs.forEach((id) => {
        promises.push(marketFuncs.getPrice(id, "month"));
      });
      return Promise.all(promises);
    },

    getHalfYear: async (tokens: string[], tokenIDs: idType[], date: string) => {
      let promises: any[] = [];
      let geckoIDs: string[] = [];
      tokens.map((token) => {
        geckoIDs.push(findGeckoId(token, tokenIDs).id);
      });
      geckoIDs.forEach((id) => {
        promises.push(marketFuncs.getPrice(id, "half-year", date));
      });
      return Promise.all(promises);
    },

    getYear: async (tokens: string[], tokenIDs: idType[], date: string) => {
      let promises: any[] = [];
      let geckoIDs: string[] = [];
      tokens.map((token) => {
        geckoIDs.push(findGeckoId(token, tokenIDs).id);
      });
      geckoIDs.forEach((id) => {
        promises.push(marketFuncs.getPrice(id, "year", date));
      });
      return Promise.all(promises);
    },
  };
};
